var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-label-form-pane" },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, "label-width": "148px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标签名称：", prop: "labelName" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入标签名称",
                  maxlength: 20,
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.labelName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "labelName", $$v)
                  },
                  expression: "form.labelName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "标签备注：" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  autosize: { minRows: 4, maxRows: 6 },
                  placeholder: "请输入标签备注",
                  maxlength: 100,
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.notice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "notice", $$v)
                  },
                  expression: "form.notice",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "标签icon：" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "space-around",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "member_label_form_icon" },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: _vm.uploadIconUrl,
                          "show-file-list": false,
                          headers: _vm.headers,
                          "on-success": _vm.handleIconSuccess,
                          "before-upload": _vm.beforeUploadIcon,
                        },
                      },
                      [
                        _vm.form.imgUrl
                          ? _c("el-image", {
                              staticClass: "member-label-image",
                              attrs: {
                                src:
                                  _vm.imgAccessDomain + "/" + _vm.form.imgUrl,
                                alt: "上传图片",
                              },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus uploader-icon",
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "upload_tip" }, [
                  _vm._v(
                    "\n          上传图片格式为jpg/png，(36px x 36px)大小不超过500kb\n        "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "标签折扣：" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, max: 100, precision: 0 },
                model: {
                  value: _vm.form.discount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "discount", $$v)
                  },
                  expression: "form.discount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "会员主题：" } }, [
            _c(
              "div",
              { staticClass: "member_label_bg_form" },
              [
                _c(
                  "el-upload",
                  {
                    attrs: {
                      action: _vm.uploadBgUrl,
                      "show-file-list": false,
                      headers: _vm.headers,
                      "on-success": _vm.handleBgSuccess,
                      "before-upload": _vm.beforeUploadBg,
                    },
                  },
                  [
                    _vm.form.bgUrl
                      ? _c("el-image", {
                          staticClass: "member-label-image",
                          attrs: {
                            src: _vm.imgAccessDomain + "/" + _vm.form.bgUrl,
                            alt: "上传图片",
                          },
                        })
                      : _c("i", { staticClass: "el-icon-plus uploader-icon" }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "upload_tip" }, [
              _vm._v(
                "\n        上传图片格式为jpg/png，(750px x 750px)大小不超过2M\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否同步cdp分组：" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.syncCdpGroup,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "syncCdpGroup", $$v)
                    },
                    expression: "form.syncCdpGroup",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [_vm._v("是")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: false } }, [_vm._v("否")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.syncCdpGroup
            ? _c(
                "el-form-item",
                { attrs: { label: "选择同步类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleCdpGrpTypeChange },
                      model: {
                        value: _vm.form.cdpGrpType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cdpGrpType", $$v)
                        },
                        expression: "form.cdpGrpType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("无")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("分组")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("消费行为"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.syncCdpGroup && _vm.form.cdpGrpType != 0
            ? _c(
                "el-form-item",
                { attrs: { label: "CDP分组" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "cdp-group-select",
                      attrs: {
                        placeholder: "请选择CDP分组",
                        clearable: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.queryCdpGroupList,
                        loading: _vm.cdpGroupLoading,
                      },
                      model: {
                        value: _vm.form.cdpGroupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cdpGroupId", $$v)
                        },
                        expression: "form.cdpGroupId",
                      },
                    },
                    _vm._l(_vm.cdpGroupOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-button", { on: { click: _vm.closeDrawer } }, [
                _vm._v("\n        取消\n      "),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveOrUpdateUserLevel },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }